import { APICore } from './apiCore';

const api = new APICore();

function surveyList(): any {
    const baseUrl = '/surveys';
    return api.getWithoutQuery(`${baseUrl}`, { headers: { 'Content-Type': 'application/json', Accept: "*/*", Authorization: `Bearer ${api.getLoggedInUser().token}` }});
}


function surveyShow(params: any): any {
    const baseUrl = '/surveys/' + params;
    return api.getWithoutQuery(`${baseUrl}`, { headers: { 'Content-Type': 'application/json', Accept: "*/*", Authorization: `Bearer ${api.getLoggedInUser().token}` }});
}

function surveyFilter(params: any): any {
    const baseUrl = '/surveys';
    console.log(baseUrl)
    return api.get(`${baseUrl}`, params,{ headers: { 'Content-Type': 'application/json', Accept: "*/*", Authorization: `Bearer ${api.getLoggedInUser().token}` }});
}

export { surveyList, surveyShow, surveyFilter };